import React, { useRef, useState, useEffect } from 'react';
import { A11y, Pagination, Mousewheel, Lazy } from 'swiper';
import { Swiper as SwiperInstance, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import ProductImage from './ProductImage';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
const swiperModules = [A11y, Mousewheel, Lazy, Pagination];
const ProductTileCarousel = (props) => {
    var _a, _b, _c, _d, _e;
    const { t } = useTranslation();
    const swiperRef = useRef();
    // const firstMove = useRef<boolean>(false);
    const [allowTransform, setAllowTransform] = useState(false);
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '200px 0px',
    });
    const paginationWrapper = useRef();
    useEffect(() => {
        var _a;
        if (swiperRef.current) {
            (_a = swiperRef.current.el.querySelectorAll('img.swiper-lazy-loaded')) === null || _a === void 0 ? void 0 : _a.forEach((el) => el.classList.remove('swiper-lazy-loaded'));
            swiperRef.current.lazy.loadInSlide(swiperRef.current.activeIndex);
        }
    }, [props.productId]);
    const lazyLoadSwiperSlides = (swiper) => {
        var _a;
        if (!((_a = swiper === null || swiper === void 0 ? void 0 : swiper.slides) === null || _a === void 0 ? void 0 : _a.length))
            return;
        // Lazy Loading images starting from second slide (index number 1)
        for (let slideNum = 1; slideNum < swiper.slides.length; slideNum++) {
            swiper.lazy.loadInSlide(slideNum);
        }
    };
    let imagesLength = 0;
    const createImageAttrs = (imageIndex) => {
        return {
            className: classNames('product-tile__image carousel-image', { 'swiper-lazy': imageIndex > 0 }),
            productId: props.productId,
            img: props.img,
            lazyDisabled: imageIndex === 0,
            animatedImage: true,
            imgQuality: props.imgQuality,
            ariaHidden: false,
        };
    };
    return (React.createElement("div", { ref: ref, "aria-label": "images slider", "aria-roledescription": "carousel" },
        inView ? (React.createElement(React.Fragment, null,
            React.createElement(SwiperInstance, { onSwiper: (swiper) => {
                    swiperRef.current = swiper;
                    props.isSimplified && paginationWrapper.current.style.setProperty('--bullets-number', imagesLength.toString());
                }, onSliderFirstMove: (swiper) => {
                    // This is used to activate Swiper's lazyLoad on tiles touch
                    lazyLoadSwiperSlides(swiper);
                }, navigation: {
                    nextEl: `.tile-carousel__next--${props.productUuid}`,
                    prevEl: `.tile-carousel__prev--${props.productUuid}`,
                }, lazy: { loadOnTransitionStart: true }, a11y: {
                    enabled: true,
                    slideRole: 'group',
                    itemRoleDescriptionMessage: 'slide',
                    slideLabelMessage: '',
                    prevSlideMessage: t('label.previouspicture'),
                    nextSlideMessage: t('label.nextpicture'),
                }, className: classNames('product-tile--carousel', { hovering: props.isOver, 'allow-transform': allowTransform }), spaceBetween: 0, initialSlide: props.initialSlide || 0, speed: 500, threshold: 0, modules: swiperModules, pagination: !props.hideCarouselPagination && {
                    enabled: true,
                    clickable: true,
                    el: paginationWrapper.current,
                }, mousewheel: {
                    forceToAxis: true,
                    thresholdDelta: 20,
                    // sensitivity: 10,
                }, resistance: true, resistanceRatio: 0, 
                // loop
                // loopPreventsSlide={false}
                // OE-17878
                slidesPerView: 1, centeredSlides: true, 
                // End OE-17878
                onBeforeSlideChangeStart: (swiper) => {
                    window.isMobile() && setAllowTransform(true);
                    lazyLoadSwiperSlides(swiper);
                    setTimeout(() => {
                        swiper.pagination.bullets.map((bullet) => {
                            bullet.setAttribute('tabIndex', '-1');
                            bullet.setAttribute('aria-hidden', 'true');
                        });
                    }, 150);
                }, onSlideChange: (swiper) => {
                    props.isSimplified && paginationWrapper.current.style.setProperty('--bullets-active-offset', swiper.activeIndex * (100 / imagesLength) + '%');
                }, onAfterInit: (swiper) => {
                    if (!props.hideCarouselPagination) {
                        setTimeout(() => {
                            window.isMobile() && swiper.pagination.el.addEventListener('touchstart', () => setAllowTransform(true));
                            swiper.pagination.el.setAttribute('aria-hidden', 'true');
                            swiper.pagination.bullets.map((bullet) => {
                                bullet.setAttribute('tabIndex', '-1');
                                bullet.setAttribute('aria-hidden', 'true');
                            });
                        }, 150);
                    }
                }, onMouseEnter: () => {
                    let outherCarousel = swiperRef.current.el.closest('.swiper-wrapper');
                    console.log('onMouseEnter outherCarousel', outherCarousel);
                } },
                props.genderImageSorted && ((_a = props.img) === null || _a === void 0 ? void 0 : _a[props.genderImageSorted])
                    ? (_c = (_b = props.img) === null || _b === void 0 ? void 0 : _b[props.genderImageSorted]) === null || _c === void 0 ? void 0 : _c.map((url, index) => {
                        if (index <= 2) {
                            const imageIndex = imagesLength;
                            imagesLength++;
                            return (React.createElement(SwiperSlide, { key: index, "data-image-index": imageIndex },
                                React.createElement(ProductImage, Object.assign({ index: index, genderImageSorted: props.genderImageSorted }, createImageAttrs(imageIndex), { ariaHidden: true }))));
                        }
                    })
                    : (_e = (_d = props.img) === null || _d === void 0 ? void 0 : _d.urls) === null || _e === void 0 ? void 0 : _e.map((url, index) => {
                        if (index <= 3 && url &&
                            !url.includes('_' + (props.exlude || 'F'))) {
                            const imageIndex = imagesLength;
                            imagesLength++;
                            return ( // exclude F which is a duplicate of X
                            React.createElement(SwiperSlide, { key: index, "data-image-index": imageIndex },
                                React.createElement(ProductImage, Object.assign({ index: index, productUuid: props.productUuid }, createImageAttrs(imageIndex), { ariaHidden: true }))));
                        }
                    }),
                imagesLength > 1 && (React.createElement(React.Fragment, null,
                    React.createElement("button", { type: "button", className: `button button--tertiary-inverted button--arrow-left product-tile-carousel__button tile-carousel__prev--${props.productUuid}` }),
                    React.createElement("button", { type: "button", className: `button button--tertiary-inverted button--arrow-right product-tile-carousel__button tile-carousel__next--${props.productUuid}` })))))) : (React.createElement("div", { className: "swiper-slide-preload" },
            React.createElement(ProductImage, { productId: props.productId, img: props.img, className: classNames('product-tile__image carousel-image'), productUuid: props.productUuid, lazyLowRes: props.lazyLowRes, animatedImage: true }))),
        props.isSimplified && React.createElement("div", { ref: paginationWrapper })));
};
export default ProductTileCarousel;
